import { Paper, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import { browserHistory } from "react-router";
import ConfigData from "../../master/components/ConfigData";
import LlpParts from "./LlpParts";
import EngineLlpsModule from "./EngineLlpsModule";
const EngineLlpsConfig = () => {
    const [tabValue, setTabValue] = useState(window.location.search.includes('llp-parts') ? 1 : 0);
    const handleTabChange = (tabindex) => {
        setTabValue(tabindex);
        if (tabindex === 1) {
            browserHistory.push('/config-data/engineLlpsConfig/?llp-parts');
        } else {
            browserHistory.push('/config-data/engineLlpsConfig');
        }
    };
    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '0px' }}>
                    <div style={{ padding: '4px 8px' }}>
                        <Paper>
                            <Tabs
                                value={tabValue}
                                onChange={(event, tabindex) => handleTabChange(tabindex)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Module/Description" />
                                <Tab label="LLPs Parts" />
                            </Tabs>
                        </Paper>
                        {tabValue === 0 ? <EngineLlpsModule /> : <LlpParts />}
                    </div>
                </div>
            </Paper>
        </section>
    );
};
export default EngineLlpsConfig;